appSocial.service('Trade', ['SocialConstants', function (SocialConstants) {
    /**
     * @name Trade
     * @class
     */
    class Trade {
        constructor(data = {}) {

            this.constants = SocialConstants;

            this.symbol = data.symbol;
            this.digits = data.digits;
            // this.digitsFormat = `1.${this.digits}-${this.digits}`;
            this.cmd = data.cmd;
            this.action = SocialConstants.actionsId[data.cmd];
            this.volume = data.volume;
            this.openTime = data.open_time;
            this.openPrice = data.open_price;
            this.stopLoss = data.sl;
            this.takeProfit = data.tp;
            this.closeTime = data.close_time;
            this.closePrice = data.close_price;
            this.profit = data.profit;
            this.userCurrency = data.user_currency;
            this.conversionRate = data.usd_converter; //to USD
            this.market = data.market;
            this.risk = data.risk;
            this.commissions = data.commissions;
            this.openVolume = data.open_volume;
            this.closeVolume = data.close_volume;
            this.spreadMoney = data.spread_money; //???
            this.markup = data.markup;
            this.taxes = data.taxes;
            this.swaps = data.swaps;
            this.duration = this.closeTime
                ? this.closeTime - this.openTime
                : Math.round(Date.now() / 1000) - this.openTime;
            this.change = data.change;

            // expanded/closed trade card
            this.expanded = false;

            // flags
            if (this.market === 'Crypto' || this.market === 'Currencies') {
                this.nameLeft = data.symbol.replace('/', '').slice(0, 3).toLowerCase();
                this.nameRight = data.symbol.replace('/', '').slice(3, 6).toLowerCase();
                const flagClass = 'flag-icon-';
                this.flagLeft = flagClass + this.getAssetCountry(this.nameLeft);
                this.flagRight = flagClass + this.getAssetCountry(this.nameRight);
            } else {
                this.flagFallback = 'todo';
            }
        }


        getAssetCountry(assetName) {
            return this.constants.symbols.symbolSubst.hasOwnProperty(assetName)
                ? this.constants.symbols.symbolSubst[assetName]
                : assetName;
        }
    }
    return Trade;
}])
